/**
 * EduOK CRM design tokens — single source of truth for MUI theme + CSS variables.
 */
export const crmColors = {
  primary: {
    main: '#5B8DD6',
    dark: '#3D6BA8',
    darker: '#2D4F7A',
    light: '#E8F0FA',
    surfaceMuted: '#B5D4F0',
    accent: '#8BB3E3',
    contrastText: '#ffffff',
  },
  secondary: {
    main: '#475569',
    light: '#94A3B8',
    dark: '#334155',
    contrastText: '#ffffff',
  },
  success: {
    main: '#10b981',
    light: '#34d399',
    dark: '#059669',
  },
  warning: {
    main: '#f59e0b',
    light: '#fbbf24',
    dark: '#d97706',
  },
  error: {
    main: '#ef4444',
    light: '#f87171',
    dark: '#dc2626',
  },
  info: {
    main: '#0EA5E9',
    light: '#7DD3FC',
    dark: '#0284C7',
  },
  background: {
    default: '#f1f5f9',
    paper: '#ffffff',
  },
  text: {
    primary: '#0f172a',
    secondary: '#64748b',
    disabled: '#94a3b8',
  },
  border: {
    default: '#E2E8F0',
    hover: '#CBD5E1',
    primaryTint: 'rgba(91, 141, 214, 0.25)',
    primarySubtle: 'rgba(91, 141, 214, 0.1)',
  },
  divider: '#E2E8F0',
  whatsapp: '#25D366',
}

export default crmColors
